import React from 'react';
import './index.scss';
import { BrowserRouter } from 'react-router';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initPayPortal3DumbleData } from './DumbleData';

initPayPortal3DumbleData();

const domNode = document.getElementById('root');

if (domNode) {
	const root = createRoot(domNode);
	root.render(
		<React.StrictMode>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</React.StrictMode>
	);
} else {
	console.error('Root element not found. Unable to render the app.');
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
